<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters class="text-center go-to-answers-row">
        <v-col cols="12">
          <p class="mb-5">
            {{ $t("surveyGoToIndividualstab") }}
          </p>
          <v-btn
            data-testid="go-to-answers-button"
            type="submit"
            color="accent"
            min-width="260"
            dark
            elevation="0"
            class="rounded-l text-none px-4 mb-5 white--text"
            @click="redirectToIndividualAnswers"
          >
            {{ $t("goToAnswers") }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
          <v-textarea
            dense
            outlined
            readonly
            :value="user[question.qid].answer"
            rows="4"
            cols="50"
          ></v-textarea>
        </v-col>
      </v-row>
    </div>
    <v-textarea
      v-else
      dense
      outlined
      disabled
      class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
      :placeholder="$t('surveyTextareaParticipantPlaceholder')"
      data-testid="open-textarea"
      :hide-details="true"
    />
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [repeatedMethodsMixin],

  methods: {
    redirectToIndividualAnswers(){
      this.$router.push({name: 'SurveyIndividuals', params: {id: this.$route.params.id, surveyId: this.$route.params.surveyId}})
    }
  }
};
</script>
